import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { ComboBoxViewModel } from '../../ViewModels/ComboBoxViewModel';
import React from 'react';
export class ComboBox extends WMComponent {
    constructor(props) {
        super(props, ComboBoxViewModel);
        this.comboBoxRef = React.createRef();
        this._isVisibleContextMenu = false;
        this.onClick = () => {
            if (!this.props.enabled) {
                return;
            }
            if (!this._isVisibleContextMenu) {
                const comboBoxElement = this.comboBoxRef.current;
                const { x, y, width, height } = comboBoxElement.getBoundingClientRect();
                const spaceFromCombobox = 1;
                const posY = y + height + spaceFromCombobox;
                const posX = x;
                showContextMenu({
                    x: posX,
                    y: posY,
                    minWidth: width,
                    items: this.state.menuItems,
                    functions: {
                        closeCallback: () => {
                            this._isVisibleContextMenu = false;
                        }
                    }
                });
            }
            else {
                this._isVisibleContextMenu = false;
                hideContextMenu();
            }
        };
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        if (this._isVisibleContextMenu) {
            hideContextMenu();
        }
    }
    render() {
        var _a;
        if (!this.props.visible) {
            return null;
        }
        const { enabled } = this.props;
        const isDisabled = !enabled || !isValidArray(this.state.menuItems);
        return (_jsxs("div", { onClick: this.onClick, className: `js-combobox${isDisabled ? ' disabled' : ''}`, ref: this.comboBoxRef, children: [_jsx("div", { children: (_a = this.state.selectedItem) === null || _a === void 0 ? void 0 : _a.text }), _jsx("div", { className: "js-combobox-right-container", children: _jsx("div", { className: "js-combobox-arrow-down", style: { display: 'block' }, children: _jsx("svg", { children: _jsx("use", { xlinkHref: "assets/webdesktop/web-desktop-sprite.svg#ArrowDown" }) }) }) })] }));
    }
}
